import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { DataResponse, GetActivitySchema, GetNpsActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetNpsActivityResponseDataSchema>>

type Query = z.input<typeof GetActivitySchema>

type Props = {
  enabled?: boolean
  query?: Query
}

export const NpsActivityQuery = ({ enabled = false, query }: Props = {}) => {
  return queryOptions({
    queryKey: ["npsActivity", JSON.stringify(query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/activity/nps`, { params: query })
      return response.data.data
    },
    staleTime: 2 * MINUTES_TO_MILLIS,
    enabled,
  })
}
